import { motion } from "framer-motion";
import { DoorOpen, PenTool } from "lucide-react";
import Particles from "@/components/Particles";
import { AUTHOR_STUDIO } from "@/data";

export default function AuthorStudio({ onBack }) {
  const a = AUTHOR_STUDIO;
  return (
    <motion.div
      key="studio"
      className="relative min-h-screen w-full overflow-hidden"
      style={{ background: a.gradient }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
      data-testid="author-studio-screen"
    >
      <Particles variant="sparkles" color="#FFE08A" count={30} />
      <Particles variant="bokeh" color="#FFD166" count={10} />
      <div className="wv-grain" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1.5" style={{ background: a.accent }} />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-6 py-24 text-center">
        <motion.div
          initial={{ scale: 0, rotate: -20 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ delay: 0.3, type: "spring", stiffness: 200, damping: 14 }}
          className="mb-6 flex h-16 w-16 items-center justify-center rounded-full border-2"
          style={{ borderColor: a.accent, boxShadow: `0 0 30px ${a.accentSoft}` }}
        >
          <PenTool className="h-7 w-7" style={{ color: a.accent }} />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45, duration: 0.7 }}
          className="font-display text-3xl tracking-tight text-white sm:text-4xl"
        >
          {a.name}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="kr mt-2 text-base"
          style={{ color: a.accent }}
        >
          {a.koreanName}
        </motion.p>

        <div className="mt-10 space-y-5">
          {a.lines.map((line, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9 + i * 0.5, duration: 0.7 }}
              className="text-base leading-relaxed text-white/80 sm:text-lg"
            >
              {line}
            </motion.p>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9 + a.lines.length * 0.5 + 0.3, duration: 0.8 }}
          className="mt-8 font-display text-sm tracking-wide"
          style={{ color: a.accent }}
        >
          {a.signature}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.9 + a.lines.length * 0.5 + 0.7, duration: 0.8 }}
          className="kr mt-10 rounded-2xl border px-6 py-4 text-sm"
          style={{ borderColor: a.accentSoft, background: `${a.accent}14`, color: "#fff" }}
        >
          {a.finalKr}
        </motion.div>
      </div>

      <button
        onClick={onBack}
        data-testid="studio-back"
        className="fixed bottom-7 left-7 z-30 flex items-center gap-2 rounded-full border border-white/15 bg-black/50 px-5 py-3 text-sm text-white/80 backdrop-blur-md transition-colors hover:border-white/40 hover:text-white"
      >
        <DoorOpen className="h-4 w-4" /> Back to lobby
      </button>
    </motion.div>
  );
}
